var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00058 0H8.99942C4.02918 0 0 4.02918 0 8.99942V9.00058C0 13.9708 4.02918 18 8.99942 18H9.00058C13.9708 18 18 13.9708 18 9.00058V8.99942C18 4.02918 13.9708 0 9.00058 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.36009 13H5.25213L8.45668 4.27273H9.54759L12.7521 13H11.6442L9.03622 5.65341H8.96804L6.36009 13ZM6.76918 9.59091H11.2351V10.5284H6.76918V9.59091Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_64"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndet);
export default __webpack_public_path__ + "static/media/ANDET.55d01c41cccc1aad842b960b9d71a294.svg";
export { ForwardRef as ReactComponent };